import React__default from "react";
import { useFloating, useTransitionStatus, useClick, useDismiss, useRole, useInteractions } from "@floating-ui/react";
const useModal = (props) => {
  const { open, onOpenChange, isClosable } = props;
  const [labelId, setLabelId] = React__default.useState();
  const data = useFloating({
    open,
    onOpenChange
  });
  const outsidePress = typeof isClosable === "boolean" ? isClosable : isClosable === "backdrop";
  const context = data.context;
  const transitionStatus = useTransitionStatus(context, { duration: 600 });
  const click = useClick(context, {
    enabled: open !== null
  });
  const dismiss = useDismiss(context, { outsidePressEvent: "mousedown", outsidePress });
  const role = useRole(context);
  const interactions = useInteractions([click, dismiss, role]);
  const opened = useDelayedOpen(transitionStatus.status === "open", 600);
  return React__default.useMemo(
    () => ({
      ...interactions,
      ...data,
      ...context,
      labelId,
      setLabelId,
      ...transitionStatus,
      opened
    }),
    [interactions, data, context, labelId, transitionStatus, opened]
  );
};
function useDelayedOpen(open, durationMs) {
  const [opened, setOpened] = React__default.useState(open);
  if (!open && opened) {
    setOpened(false);
  }
  React__default.useEffect(() => {
    if (open && !opened) {
      const timeout = setTimeout(() => setOpened(true), durationMs);
      return () => clearTimeout(timeout);
    }
  }, [open, opened, durationMs]);
  return opened;
}
export {
  useModal
};
